import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';
import ModalOverlay from '../../../components/ui/ModalOverlay/ModalOverlay';
import s from '../CaseFilePage.module.css';

interface NoteModalProps {
  noteText: string;
  setNoteText: (v: string) => void;
  noteContact: { phone: boolean; email: boolean; none: boolean };
  setNoteContact: React.Dispatch<
    React.SetStateAction<{ phone: boolean; email: boolean; none: boolean }>
  >;
  handleAddNote: () => void;
  isPending: boolean;
  onClose: () => void;
}

export default function NoteModal({
  noteText,
  setNoteText,
  noteContact,
  setNoteContact,
  handleAddNote,
  isPending,
  onClose,
}: NoteModalProps) {
  return (
    <ModalOverlay onClose={onClose} title="Add Case Note">
      <div className={s.modalForm}>
        <div className={s.formGroup}>
          <label>Note</label>
          <textarea
            rows={5}
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
            placeholder="Enter note…"
          />
        </div>
        <div className={s.checkboxRow}>
          <label>
            <input
              type="checkbox"
              checked={noteContact.phone}
              onChange={(e) => setNoteContact((p) => ({ ...p, phone: e.target.checked }))}
            />
            Phone Contact
          </label>
          <label>
            <input
              type="checkbox"
              checked={noteContact.email}
              onChange={(e) => setNoteContact((p) => ({ ...p, email: e.target.checked }))}
            />
            Email Contact
          </label>
          <label>
            <input
              type="checkbox"
              checked={noteContact.none}
              onChange={(e) => setNoteContact((p) => ({ ...p, none: e.target.checked }))}
            />
            No Contact
          </label>
        </div>
        <div className={s.modalActions}>
          <button className={s.btnSecondary} onClick={onClose}>
            Cancel
          </button>
          <button
            className={s.btnPrimary}
            onClick={handleAddNote}
            disabled={!noteText.trim() || isPending}
          >
            {isPending ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <FontAwesomeIcon icon={faCheck} />
            )}
            Publish Note
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
